export * from './applet-manager';
